import React from "react";
import { LOCAL_PATH } from "../constant";

const HomePage = React.lazy(() => import("../containers/Home"));
const Cartpage = React.lazy(() => import("../containers/Cart"));
const CartsPage = React.lazy(() => import("../containers/Carts"));
const StatusVMpage = React.lazy(() => import("../containers/StatusVM"));
const VMProductPage = React.lazy(() => import("../containers/VMProduct"));
const BillSuccesPage = React.lazy(() => import("../containers/BillSuccess"));
const BillFailPage = React.lazy(() => import("../containers/BillFail"));
const LuckyDraw = React.lazy(() => import("../containers/LuckyDraw"));
const ResultPaymentPage = React.lazy(() => import("../containers/ResultPayment"));
const ResultPaymentNescafePage = React.lazy(() => import("../containers/ResultPaymentNescafe"));
const WaittingPage = React.lazy(() => import("../containers/Waitting"));
const SquatGame = React.lazy(() => import("../containers/SquatGame"));
const SquatRegister = React.lazy(() => import("../containers/SquatGame/register"));
const CustomerCarePage = React.lazy(() => import("../containers/CustomerCare"));
const CashLeftOverMBpage = React.lazy(() => import("../containers/CashLeftOverMB"));
const ViewVideoGame = React.lazy(() => import("../containers/ViewVideoGame"));
const ViewVideoGameCloned = React.lazy(() => import("../containers/ViewVideoGame/cloned"));
const SurveyPage = React.lazy(() => import("../containers/Survey"));
const SurveyBeforePage = React.lazy(() => import("../containers/SurveyBefore"));
const BillPage = React.lazy(() => import("../containers/Bill"));
const ChangeBankPage = React.lazy(() => import("../containers/ChangeBank"));
const HealthCheck = React.lazy(() => import("../containers/HealthCheck"));
const LuckyDrawCard = React.lazy(() => import("../containers/LuckyDrawCard"));
const LuckyPoster = React.lazy(() => import("../containers/LuckyPoster"));
const LuckyPosterSeriA = React.lazy(() => import("../containers/LuckyPosterSeriA"));
const LuckyPosterSeriB = React.lazy(() => import("../containers/LuckyPosterSeriB"));
const LuckySpecial = React.lazy(() => import("../containers/LuckySpecial"));
const LuckyWheely = React.lazy(() => import("../containers/LuckyWheely"));
const HitTheMouse = React.lazy(() => import("../containers/HitTheMouse"));
const ChoosePosition = React.lazy(() => import("../containers/ChoosePosition"));
const AboutKootoro = React.lazy(() => import("../containers/AboutKootoro"));
const VendingModel = React.lazy(() => import("../containers/VendingModel"));
const VendingModelDetail = React.lazy(() => import("../containers/VendingModel/detail"));
const Question = React.lazy(() => import("../containers/Question"));
const VMContact = React.lazy(() => import("../containers/Contact"));


export interface IRouter {
  path: string;
  title: string;
  icon?: any;
  component?: any;
}

const appRouter: IRouter[] = [
  {
    path: LOCAL_PATH.HOME,
    title: "Home",
    component: HomePage,
  },
  {
    path: LOCAL_PATH.PRODUCT,
    title: "Product",
    component: VMProductPage,
  },
  {
    path: LOCAL_PATH.CART,
    title: "Product detail",
    component: Cartpage,
  },
  {
    path: LOCAL_PATH.CARTS,
    title: "Carts",
    component: CartsPage,
  },
  {
    path: LOCAL_PATH.STATUS_VM,
    title: "Status",
    component: StatusVMpage,
  },
  {
    path: LOCAL_PATH.BILL,
    title: "Bill",
    component: BillPage,
  },
  {
    path: LOCAL_PATH.BILL_SUCCESS,
    title: "Bill Success",
    component: BillSuccesPage,
  },
  {
    path: LOCAL_PATH.BILLS_FAIL,
    title: "Bill Fail",
    component: BillFailPage,
  },
  {
    path: LOCAL_PATH.LUCKY_DRAW,
    title: "Lucky Draw",
    component: LuckyDraw,
  },
  {
    path: LOCAL_PATH.LUCKY_DRAW_CARD,
    title: "Lucky Draw Card",
    component: LuckyDrawCard,
  },
  {
    path: LOCAL_PATH.SQUAT_GAME,
    title: "Squat Game",
    component: SquatGame,
  },
  {
    path: LOCAL_PATH.GAME_REGISTER,
    title: "Squat Game",
    component: SquatRegister,
  },
  {
    path: LOCAL_PATH.VIEW_VIDEO_GAME,
    title: "View Video",
    component: ViewVideoGame,
  },
  {
    path: LOCAL_PATH.VIEW_VIDEO_GAME_CLONE,
    title: "View Video Cloned",
    component: ViewVideoGameCloned,
  },
  {
    path: LOCAL_PATH.RESULT_PAYMENT,
    title: "Result Payment",
    component: ResultPaymentPage,
  },
  {
    path: LOCAL_PATH.WAITTING,
    title: "Waitting",
    component: WaittingPage,
  },
  {
    path: LOCAL_PATH.RESULT_PAYMENT_NESCAFE,
    title: "Result Payment Nescafe",
    component: ResultPaymentNescafePage,
  },
  {
    path: LOCAL_PATH.CUSTOMER_CARE,
    title: "Customer care",
    component: CustomerCarePage,
  },
  {
    path: LOCAL_PATH.CASH_LEFT_OVER,
    title: "Cash left over",
    component: CashLeftOverMBpage,
  },
  {
    path: LOCAL_PATH.SURVEY,
    title: "Survey",
    component: SurveyPage,
  },
  {
    path: LOCAL_PATH.SURVEY_BEFORE,
    title: "Survey before",
    component: SurveyBeforePage,
  },
  {
    path: LOCAL_PATH.CHANGE_BANK,
    title: "Change bank",
    component: ChangeBankPage,
  },
  {
    path: LOCAL_PATH.LUCKY_POSTER,
    title: "Lucky Poster",
    component: LuckyPoster,
  },
  {
    path: LOCAL_PATH.LUCKY_POSTER_SERI_A,
    title: "Lucky Poster seri a",
    component: LuckyPosterSeriA,
  },
  {
    path: LOCAL_PATH.LUCKY_POSTER_SERI_B,
    title: "Lucky Poster seri b",
    component: LuckyPosterSeriB,
  },
  {
    path: LOCAL_PATH.LUCKY_SPECIAL,
    title: "Lucky Special",
    component: LuckySpecial,
  },
  {
    path: LOCAL_PATH.LUCKY_WHEELY,
    title: "Lucky Wheely",
    component: LuckyWheely,
  },
  {
    path: LOCAL_PATH.HIT_THE_MOUSE,
    title: "Hit The Mouse",
    component: HitTheMouse,
  },
  {
    path: LOCAL_PATH.HEALTH_CHECK,
    title: "Health Check",
    component: HealthCheck,
  },
  {
    path: LOCAL_PATH.CHOOSE_POSITION,
    title: "Choose Position",
    component: ChoosePosition,
  },
  {
    path: LOCAL_PATH.ABOUT_KOOTORO,
    title: "About Kootoro",
    component: AboutKootoro,
  },
  {
    path: LOCAL_PATH.VENDING_MODEL,
    title: "Vending Model",
    component: VendingModel,
  },
  {
    path: LOCAL_PATH.QUESTION,
    title: "Question",
    component: Question,
  },
  {
    path: LOCAL_PATH.CONTACT,
    title: "Contact",
    component: VMContact,
  },
  {
    path: LOCAL_PATH.VENDING_MODEL_DETAIL,
    title: "Vending Model Detail",
    component: VendingModelDetail,
  },
];

export default appRouter;
